import { render } from "./pb-gallery.vue?vue&type=template&id=9a66aba4"
import script from "./pb-gallery.vue?vue&type=script&lang=js"
export * from "./pb-gallery.vue?vue&type=script&lang=js"

import "./pb-gallery.vue?vue&type=style&index=0&id=9a66aba4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__